class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];

      if (target && html) {
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
    this.updateShippingMessage();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  updateShippingMessage() {
    const shippingBox = this.querySelector('#cart-notification-shipping');
    if (!shippingBox) return;

    if (shippingBox.dataset.country !== 'FR') {
      shippingBox.innerHTML = '';
      shippingBox.hidden = true;
      return;
    }

    shippingBox.hidden = false;
    const threshold = 2000;

    fetch(`${routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cart) => {
        const total = Number(cart.total_price || 0);

        if (total >= threshold) {
          shippingBox.innerHTML =
            '<strong>✓ Livraison offerte activée !</strong><span>Pour votre commande en France.</span>';
        } else {
          const remaining = Math.max(0, threshold - total);
          const amount = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: cart.currency || 'EUR',
          }).format(remaining / 100);

          shippingBox.innerHTML =
            `<strong>🚚 Encore ${amount} → offerte</strong>` +
            '<span>Livraison France : 9,90 € sous 20 €.</span>';
        }
      })
      .catch(() => {
        // La notification reste fonctionnelle même si le calcul de livraison ne se rafraîchit pas.
      });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
